<template>
  <cbr-modal
    :class="$style.map"
    :show="show"
    @close="$emit('close')">
    <div
      class="c-cbr-MapOverlay showMap"
      @click="$emit('close')">
      <div
        class="c-cbr-MapOverlay-inner showMapInner"
        @click.stop.prevent>
        <div class="c-cbr-MapOverlay-mapContainer">
          <v-map
            :center="coordinates"
            :zoom="zoomLevel">
            <v-tilelayer url="https://{s}.tile.osm.org/{z}/{x}/{y}.png" />
            <v-marker
              v-for="(item, key) in computedMarkers"
              :key="key"
              :draggable="item.draggable"
              :icon="item.icon"
              :lat-lng="item.position"
              @l-click="selectDropShopById(item.id);scrollToShop(item.id);"
            >
              <v-tooltip :content="item.tooltip" />
            </v-marker>
          </v-map>
        </div>

        <div class="c-cbr-MapOverlay-searchBox">
          <div
            :style="{color:pageTextColor}"
            class="c-cbr-MapOverlay-searchBoxHeader">
            <span
              v-if="formDataCountry === 'SE'">
              {{ $t('psf.se_next_parcel_shops') }}</span>
            <span
              v-else-if="formDataCountry === 'IT'">
              {{ $t('psf.it_next_parcel_shops') }}</span>
            <span
              v-else-if="formDataCountry === 'FR'">
              {{ $t('psf.fr_next_parcel_shops') }}</span>
            <span
              v-else-if="formDataCountry === 'FI'">
              {{ $t('psf.fi_next_parcel_shops') }}</span>
            <span
              v-else>
              {{ $t('psf.next_parcel_shops') }}</span>
            <obj-link
              aligned="right"
              @click="$emit('close')">
              <div :class="$style.closeIcon" />
            </obj-link>
          </div>

          <div
            v-if="!searchDivMinimized"
            class="c-cbr-MapOverlay-searchBoxForm">
            <form
              action
              data-vv-scope="mapSearchFormData"
              @submit.prevent>
              <div class="c-cbr-FormField-col">
                <label
                  :style="{color:fieldTextColor}"
                  class="c-cbr-FormField-label"
                  for="address"
                >{{ `${$t('form.address')} (${$t('form.street')} + ${$t('form.city')}/${$t('form.postal_code')})` }}</label>

                <input
                  id="address"
                  v-model="address"
                  class="c-cbr-FormField-input"
                  name="street"
                  type="text"
                  @keyup.enter="search()"
                >
              </div>

              <div class="c-cbr-FormField-col">
                <label
                  :style="{color:fieldTextColor}"
                  class="c-cbr-FormField-label"
                  for="distance-select"
                >{{ $t('form.distance') }}</label>
                <div class="c-cbr-FormField-select-wrapper">
                  <select
                    id="distance-select"
                    v-model="distance"
                    class="c-cbr-FormField-input"
                    @change="search()"
                  >
                    <option
                      v-for="(option, key) in distanceOptions"
                      :key="key"
                      :value="option.value"
                    >{{ option.text }}</option>
                  </select>
                </div>
              </div>
            </form>
          </div>
          <div v-else>
            <div :class="$style.addressField">
              <div>
                <b><img
                  :style="{'max-height':'13px'}"
                  alt="Marker icon"
                  src="/assets/marker-icon.png"
                >   {{ $t('parcelshop.your_address') }}</b>
              </div>
              <div>
                <obj-link
                  v-if="currentLanguage === 'de'"
                  aligned="right"
                  @click="maximiseSearchDiv">{{ $t('return.specific_show_more') }}</obj-link>
                <obj-link
                  v-else
                  aligned="right"
                  @click="maximiseSearchDiv">{{ $t('return.show_more') }}</obj-link>
              </div>
            </div>
            {{ address }}
            <hr >
          </div>
        </div>

        <div
          v-if="!dropShops"
          class="c-cbr-MapOverlay-noResults">
          <span
            v-if="formDataCountry === 'IT'"
            v-html="$t('return.it_no_parcelshop_nearby_psf')" />
          <span
            v-else-if="formDataCountry === 'FR'"
            v-html="$t('return.fr_no_parcelshop_nearby_psf')" />
          <span
            v-else
            v-html="$t('return.no_parcelshop_nearby_psf')" />
        </div>

        <div v-else-if="pendingRequests > 0">
          <obj-spinner />
        </div>

        <template v-else>
          <div class="c-cbr-MapOverlay-results">
            <div
              id="c-cbr-MapOverlay-results-shopList"
              class="c-cbr-MapOverlay-results-shopList">
              <cbr-drop-shop-mini
                v-for="dropShop in dropShops.slice(0,resultLimit)"
                :id="dropShop.id"
                :key="dropShop.id"
                :drop-shop="dropShop"
                :selected="dropShop.id === selectedDropShop.id"
              />

              <div
                v-if="resultLimit < dropShops.length"
                :class="$style.showMore">
                <obj-button
                  :is-active="true"
                  :is-wide="true"
                  class="o-button"
                  @click="showMore()"
                >{{ $t("btn.show_more") }}</obj-button>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </cbr-modal>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

import CbrModal from './CbrModal.vue'
import CbrDropShopMini from './drop-shop/CbrDropShopMini.vue'
import ObjButton from './ObjButton.vue'
import ObjLink from './ObjLink.vue'
import ObjSpinner from './ObjSpinner.vue'

export default {
  components: {
    CbrModal,
    ObjButton,
    ObjLink,
    CbrDropShopMini,
    ObjSpinner
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      distance: 5000,
      dropShop: {
        style:
          'fill:#6b1544;fill-rule:nonzero;stroke:#6b1544;stroke-width:1px;',
        fill: 'white'
      },
      dropShopSelected: {
        style: 'fill: #FFF;fill-rule:nonzero;stroke:#6b1544;stroke-width:1.5px;',
        fill: '#6b1544'
      },
      mapSearchFormData: {
        distance: 10000,
        address: ''
      },
      distanceOptions: [
        { text: '500 m', value: 500 },
        { text: '1 km', value: 1000 },
        { text: '2 km', value: 2000 },
        { text: '5 km', value: 5000 },
        { text: '10 km', value: 10000 },
        { text: '20 km', value: 20000 },
        { text: '50 km', value: 50000 }
      ],
      inputAddress: null,
      resultLimit: 25,
      pendingRequests: 0,
      searchDivMinimized: false
    }
  },
  computed: {
    ...mapState('dropShops', ['markers', 'lat', 'lng', 'dropShops']),
    ...mapGetters('dropShops', ['selectedDropShop']),
    ...mapGetters('inputData', ['formDataCountry']),
    ...mapGetters('config', [
      'buttonColor',
      'buttonTextColor',
      'fieldTextColor',
      'pageTextColor'
    ]),
    ...mapState('inputData', ['formData']),

    address: {
      get() {
        if (this.inputAddress === null) {
          /* Default / Init */
          return `${this.formData.address}, ${this.formData.postal_code} ${this.formData.city}`
        }

        return this.inputAddress
      },

      set(address) {
        this.inputAddress = address
      }
    },

    currentLanguage: {
      get: function() {
          return this.$store.state.lang.currentLanguage
        },
      set: function(val) {
          this.languageSelect(val)
        }
      },

    zoomLevel() {
      /* Handle address not found */
      if (!this.selectedDropShop) {
        return 4
      }

      const distance = this.distance

      /* Default zoomlevel === 0 */
    let zoomLevel = 20
        if (distance == 50000) {
        zoomLevel = 10
      } else if (distance == 20000) {
        zoomLevel = 11
      } else if (distance == 10000) {
        zoomLevel = 12
      } else if (distance == 5000) {
        zoomLevel = 13
      } else if (distance == 2000) {
        zoomLevel = 14
      } else if (distance == 1000) {
        zoomLevel = 15
      } else if (distance == 500) {
        zoomLevel = 16
      }
      return zoomLevel
    },

    computedMarkers() {
      if (!this.markers) {
        return false
      }

      let markerArray = this.markers.map(marker => {
        if (marker.id === this.selectedDropShop.id) {
          marker.type = 'dropShopSelected'
          marker.icon = this.markerIcon(
            this.dropShop.style,
            this.dropShop.fill,
            marker.number
          )
        } else if (marker.id !== 1) {
          marker.type = 'dropShop'
          marker.icon = this.markerIcon(
            this.dropShopSelected.style,
            this.dropShopSelected.fill,
            marker.number
          )
        }

        return marker
      })
      let homeLocation = markerArray[markerArray.length - 1]
      markerArray.unshift(homeLocation)
      return markerArray.slice(0, this.resultLimit + 1)
    },

    coordinates() {
      return this.calculateCoordinates()
    }
  },
  created() {
    !this.selectedDropShop
      ? (this.searchDivMinimized = true)
      : (this.searchDivMinimized = false)
    if (this.buttonColor !== '') {
      this.dropShop.style =
        'fill:' +
        this.buttonColor +
        ';fill-rule:nonzero;stroke:' +
        this.buttonColor +
        ';stroke-width:1px;'
      this.dropShopSelected.style =
        'fill: #FFF;fill-rule:nonzero;stroke:' +
        this.buttonColor +
        ';stroke-width:2px;'
    }
    if (this.buttonTextColor !== '') {
      this.dropShop.fill = this.buttonTextColor
      this.dropShopSelected.fill = '#000000'
    }
  },
  updated: function() {
    /* Calculate the height of the shop list */
    const shopSelected = document.getElementById(
      'c-cbr-MapOverlay-results-shopSelected'
    )
    const shopList = document.getElementById(
      'c-cbr-MapOverlay-results-shopList'
    )
    if (shopSelected && shopList) {
      const selectedHeight = shopSelected.offsetHeight
      const listHeight = `calc( 100% - ${selectedHeight + 20}px`
      shopList.style.height = listHeight
    }
  },

  methods: {
    ...mapMutations('dropShops', [
      'SET_SELECTED_DROP_SHOP',
      'SET_DISTANCE',
      'SET_ADDRESS'
    ]),

    ...mapActions('dropShops', ['selectDropShopById', 'searchDropShops']),

    markerIcon(style, fill, number) {
      return L.divIcon({
        iconSize: new L.Point(50, 50),
        html: `<div class="markerIcon"><svg width="100%" height="100%" viewBox="0 0 28 38" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;"><rect id="pin" x="0" y="0" width="27.143" height="38" style="fill:none;"/><clipPath id="_clip1"><rect x="0" y="0" width="27.143" height="38"/></clipPath><g clip-path="url(#_clip1)"><g id="pin1" serif:id="pin"><rect id="EXPORT" x="-2352.67" y="-1805.5" width="6611.8" height="5215.4" style="fill:none;"/><path d="M13.6,0.5c-7.242,0 -13.1,5.745 -13.1,12.848c0,9.636 13.1,23.861 13.1,23.861c0,0 13.1,-14.225 13.1,-23.861c0,-7.103 -5.858,-12.848 -13.1,-12.848Z" style="${style}"/></g></g><text text-anchor="middle" x="13" y="21" font-size="14px" fill="${fill}">${number}</text></svg></div>`
      })
    },

    calculateCoordinates() {
      //to have europe in the centre of the map in the beginning
      let lat = 48
      let lng = 9

      if (this.selectedDropShop) {
        lat = this.selectedDropShop.address.latitude
        lng = this.selectedDropShop.address.longitude
      } else if (this.lat && this.lng) {
        lat = this.lat
        lng = this.lng
      }

      return [lat, lng]
    },

    search() {
      this.SET_DISTANCE(this.distance)
      this.SET_ADDRESS(this.address)
      this.pendingRequests = this.pendingRequests + 1

      this.searchDropShops().then(() => {
        if (this.selectedDropShop) {
          this.searchDivMinimized = true
        }
        this.pendingRequests = 0
      })
    },

    showMore() {
      this.resultLimit += 25
    },
    scrollToShop(id) {
      var elmnt = document.getElementById(id)
      elmnt.scrollIntoView()
    },
    maximiseSearchDiv() {
      this.searchDivMinimized = false
    }
  }
}
</script>

<style module>
.map {
  cursor: pointer;
}

.closeIcon {
  width: 50px;
  height: 50px;
  background-image: url('../../assets/ico_close.svg');
}

.showMore {
  text-align: center;
  margin: 1.25rem;
}

.addressField {
  display: grid;
  grid-template-columns: 60% 40%;
  grid-gap: 5px;
}
</style>



// WEBPACK FOOTER //
// client/components/CbrMap.vue